const value = {
    all: 'Все',
    published: 'Опубликованные',
    notPublished: 'Неопубликованные',
  };

export default value;
